import React from 'react';
import { FloatingGlassDock, type DockTab } from './common/FloatingGlassDock.js';

export type ScreenTab = DockTab;

export interface NavigationProps {
  activeTab: ScreenTab;
  onSelectTab: (tab: ScreenTab) => void;
  triggerHaptic?: () => void;
}

export const Navigation: React.FC<NavigationProps> = ({
  activeTab,
  onSelectTab,
  triggerHaptic,
}) => {
  return (
    <FloatingGlassDock
      activeTab={activeTab}
      onSelectTab={onSelectTab}
      triggerHaptic={triggerHaptic}
    />
  );
};
